module.exports = __webpack_public_path__ + "img/capitano 2.6d071a33.jpeg";